<div class="flex h-full w-full flex-col items-center justify-center">
  @if (showLabel() && isUpperQuadrant()) {
    <div class="typo-h4-thin absolute top-0 pt-4 capitalize text-text-primary">{{ quadrantLabel() | translate }}</div>
  }
  <div [class]="cornerRoundingClass()" (click)="isClickable() ? quadrantClicked.emit(quadrant()) : null">
    <lib-teeth
      class="!w-auto"
      [teeth]="teeth()"
      [drawGum]="false"
      [drawCross]="false"
      [drawNumbers]="false"
      [drawTreatments]="drawTreatments()"
      [selectedTeethPositions]="selectedTeethPositions()"
      [selectedQuadrant]="quadrant()"
    />
  </div>
  @if (showLabel() && !isUpperQuadrant()) {
    <div class="typo-h4-thin absolute bottom-0 pb-4 capitalize text-text-primary">{{ quadrantLabel() | translate }}</div>
  }
</div>
